import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  showDetails: false,
  expandDetails: false,
  filterDrawerOpen: false,
  sideNavCollapsed: false,
};

const useCommonStore = create(
  devtools((set) => ({
    ...initialState,
    setShowDetails: (t) => set({ showDetails: t }),
    setExpandDetails: (t) => set({ expandDetails: t }),

    toggleShowDetails: () =>
      set((state) => ({ showDetails: !state.showDetails })),
    toggleExpandDetails: () => {
      set((state) => ({ expandDetails: !state.expandDetails }));
    },
    setFilterDrawerOpen: (isOpen) => set({ filterDrawerOpen: isOpen }),
    setSideNavCollapsed: (collapsed) => set({ sideNavCollapsed: collapsed }),

    reset: () => set(initialState),
  })),
);

export default useCommonStore;
